(function () {
  'use strict';

  angular
    .module('messageInbox')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('messageInbox', {
        url: '/message-inbox',
        views: {
          'messageInboxView': {
            templateUrl: 'message-inbox/views/message-inbox.tpl.html',
            controller: 'MessageInboxCtrl',
            controllerAs: 'messageInbox'
          }
        }
      });
  }
}());
